import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
    inject
} from "@angular/core";

@Directive({ selector: "[raskHotkey]" })
export class HotkeyDirective implements OnInit, OnDestroy {
    @Input("raskHotkey") binding: string;

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("disabled") currentControlDisabled: boolean;
    @Input() hotkeyClick = true;
    @Output() hotkeyTrigger = new EventEmitter<string>();

    private readonly element = inject(ElementRef);
    private readonly zone = inject(NgZone);

    private alt = false;
    private ctrl = false;
    private key: string;
    private shift = false;

    isTargetVisible(): boolean {
        // eslint-disable-next-line sonarjs/prefer-single-boolean-return
        if (this.element.nativeElement.offsetParent === null) {
            return false;
        }
        return true;
    }

    matchesBinding(e: KeyboardEvent): boolean {
        // eslint-disable-next-line sonarjs/prefer-single-boolean-return
        if (e.key === this.key &&
            e.ctrlKey === this.ctrl &&
            e.altKey === this.alt &&
            e.shiftKey === this.shift) {
            return true;
        }
        return false;
    }

    ngOnDestroy(): void {
        document.removeEventListener("keydown", this.onKeyDown);
    }

    ngOnInit(): void {
        this.parseBinding();
        this.zone.runOutsideAngular(() => {
            document.addEventListener("keydown", this.onKeyDown);
        });
    }

    onKeyDown = (e: KeyboardEvent) => {
        if (this.matchesBinding(e) && this.isTargetVisible()) {
            e.preventDefault();
            e.stopPropagation();
            if (this.currentControlDisabled === false) {
                if (this.hotkeyClick) {
                    this.element.nativeElement.click();
                } else {
                    this.hotkeyTrigger.emit(this.binding);
                }
            }
        }
    };

    parseBinding() {
        if (this.binding == null) {
            return;
        }
        const tokens = this.binding.split("+");
        if (tokens.length >= 2) {
            switch (tokens[0].toLocaleLowerCase()) {
                case "ctrl":
                    this.ctrl = true;
                    break;
                case "shift":
                    this.shift = true;
                    break;
                case "alt":
                    this.alt = true;
            }
            this.key = tokens[1].toLocaleLowerCase();
        } else {
            this.key = tokens[0].toLocaleLowerCase();
        }
    }
}
